import React from 'react';
import i18n from 'i18next';
import { isIOS, isAndroid, isChrome, isMobile } from 'react-device-detect';
import { IS_IFRAME_MODE } from 'config/envVariable';
import { css } from '@emotion/core';
import Typography from '@material-ui/core/Typography';
import ArrowUpwardIcon from '@material-ui/icons/ArrowUpward';

function ResultDownloadBtn({ href, componentStyle }) {
    const mobileDisplayText =
        isIOS && !(isChrome && IS_IFRAME_MODE)
            ? i18n.t('label.ugc.img.mobile_ios_download')
            : i18n.t('label.ugc.img.mobile_download');

    return (
        <a
            css={downloadDivStyle}
            href={href}
            // 只有在 iOS 且不是手機時才會使用 '_blank'
            target={isIOS && !isMobile ? '_blank' : ''}
            rel="noreferrer noopener"
            // 如果是 Android 或特定 iOS 瀏覽器 (Chrome + iframe)，才保留 download 屬性
            {...(isMobile &&
                (isAndroid || (isIOS && isChrome && IS_IFRAME_MODE)) && { download: true })}
            // 電腦版保持 download 屬性
            {...(!isMobile && { download: true })}
        >
            <ArrowUpwardIcon css={downloadIconStyle(componentStyle)} />
            <Typography variant="button" css={downloadStyle(componentStyle)}>
                {isMobile ? mobileDisplayText : i18n.t('label.ugc.img.download')}
            </Typography>
        </a>
    );
}

export default ResultDownloadBtn;

const downloadDivStyle = css`
    display: flex;
    cursor: pointer;
    text-decoration: none;
    color: #000000;
'
`;
const downloadStyle = (componentStyle = {}) => css`
    font-weight: 500;
    color: ${componentStyle.titleColor};
    word-break: break-all;
    margin-left: 13px;
`;
const downloadIconStyle = (componentStyle = {}) => css`
    color: ${componentStyle.titleColor};
`;
